export default __webpack_public_path__ + "static/media/640_portfolio02-en-web.e6812881.png";